interface ShowingsKeyParams {
  eventId: number;
  eventVenueId: number;
  promo?: string | null;
  password?: string | null;
}

export const getEventVenuePasswordStorageKey = (eventVenueId: number) =>
  `itk_eventvenue_${eventVenueId}_password`;

/** SWR key for the event showings endpoint, including the optional promo code and event venue password */
export const getShowingsKey = ({
  eventId,
  eventVenueId,
  promo,
  password,
}: ShowingsKeyParams) => {
  const params = new URLSearchParams();
  if (promo) params.set("promoCode", promo);
  if (password) params.set("password", password);
  const query = params.toString();

  return `events/${eventId}/${eventVenueId}/showings${
    query ? `?${query}` : ""
  }`;
};

/** SWR `mutate` matcher for every variation (promo code / password) of an event's showings key */
export const isShowingsKey =
  (eventId: number, eventVenueId: number) => (key: unknown) => {
    const base = `events/${eventId}/${eventVenueId}/showings`;
    return (
      typeof key === "string" && (key === base || key.startsWith(`${base}?`))
    );
  };
